import { render } from "./product-checkout.vue?vue&type=template&id=67af34a0"
import script from "./product-checkout.vue?vue&type=script&lang=js"
export * from "./product-checkout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__